var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommas(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 41,
    viewBox: "0 0 53 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 41C2.23857 41 -3.61899e-06 38.7614 -3.37758e-06 36L-1.93222e-06 19.467C-1.09869e-06 9.93251 6.88231 1.9752 15.9284 0.297226C17.2711 0.0481641 18.4234 1.14777 18.4234 2.51336C18.4234 3.76171 17.4515 4.77751 16.2341 5.05371C9.65388 6.54661 4.7281 12.4518 4.7281 19.467C4.7281 20.0634 5.19667 20.5319 5.79303 20.5319L15.4678 20.5319C18.2293 20.5319 20.4678 22.7705 20.4678 25.5319L20.4678 36C20.4678 38.7614 18.2293 41 15.4678 41L5 41Z",
    fill: "url(#paint0_linear_343_3027)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9265 41C34.1651 41 31.9265 38.7614 31.9265 36L31.9265 19.467C31.9265 9.93073 38.8114 1.97223 47.8764 0.296283C49.2191 0.0480496 50.3712 1.14756 50.3712 2.51299C50.3712 3.76148 49.3991 4.77738 48.1813 5.05256C41.5829 6.54357 36.6548 12.45 36.6548 19.467C36.6548 20.0634 37.1234 20.5319 37.7197 20.5319L47.3945 20.5319C50.156 20.5319 52.3945 22.7705 52.3945 25.5319L52.3945 36C52.3945 38.7614 50.156 41 47.3945 41L36.9265 41Z",
    fill: "url(#paint1_linear_343_3027)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_343_3027",
    x1: 16.6227,
    y1: 41,
    x2: 0.103117,
    y2: 38.5405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15C39A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09D7A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_343_3027",
    x1: 48.5494,
    y1: 41,
    x2: 32.0296,
    y2: 38.5405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15C39A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09D7A6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommas);
export default __webpack_public_path__ + "static/media/commas.0b062a0acc1f09b2d58a55a738733342.svg";
export { ForwardRef as ReactComponent };